export default "__VITE_ASSET__BHwSWRFf__"